export default "__VITE_ASSET__13626eb8__"